import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Alert } from 'antd';

import Spinner from 'components/Spinner';
import {config} from 'config/config';
import jwt from 'utils/jwt';
import useQueryApiClient from 'utils/useApiClient';

import './styles.scss';

const mapStateToProps = (state: any) => ({ session: state.session });

interface LearningActivityProps {
  learningActivityId: number;
  activityAttemptId?: number;
  type: 'learn' | 'test';
  isFirstAttempt?: boolean;
  session?: any;
  parentActivityId?: number;
  campaignId?: string;
  language?: string;
  version?: string;
  isPreview?: boolean
}

type ServerRequestType = {
    learningActivityId: number;
    activityAttemptId?: number;
    type: 'learn' | 'test';
    language?: string;
    version?: string;
    isPreview?: boolean;
}

const LearningActivity: React.FC<LearningActivityProps> = ({
  learningActivityId, activityAttemptId, type,
  isFirstAttempt, session, parentActivityId, campaignId, language, version, isPreview
}) => {
  const [source, setSource] = useState<string|null>(null);
  const [errorMessage, setErrorMessage] = useState('');

  const intl = useIntl();
  const navigate = useNavigate();

  const {appendData: createServeRequest, isLoading} = useQueryApiClient({
      request: {
          baseUrl: config.api.coursesUrl,
          method: 'POST',
          url: '/api/v1/courses/serve-request',
      },
      onSuccess: (response: any): void => {
        setSource(`${config.api.serveUrl}/serve/${response.uuid}?token=${jwt.get()}&fullName=${session.name} ${session.surname}&email=${session.email}`);

        if (isFirstAttempt) {
          consumeLicenceAccess({
            activityId: learningActivityId,
            userTypeId: session.active_user_type_id,
            customerId: session.organization.organization_id,
            parentActivityId: parentActivityId,
            campaignId: campaignId
          });
        }
      },
      onError: (err: any): void => {
        const message = err.message ?? 'campaign.learning_activity_not_found';
        setErrorMessage(message);
      },
  });

  const {appendData: consumeLicenceAccess} = useQueryApiClient({
      request: {
          method: 'POST',
          url: '/api/v1/licences/consume',
      },
  });

  useEffect(() => {
    if (session?.name) {
      loadLearningActivity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[session])

  const loadLearningActivity = async () => {
    if (!learningActivityId || !type) {
      navigate(-1);
    }

    const parsedValues: ServerRequestType = {
      learningActivityId,
      activityAttemptId,
      type
    };

    if (language) {
      parsedValues.language = language
    }

    if (version) {
      parsedValues.version = version
    }

    if (isPreview) {
      parsedValues.isPreview = isPreview
    }

    createServeRequest(parsedValues);
  }
  
  return (
    <Spinner spinning={isLoading}>
      {errorMessage && (
        <Alert
          message={intl.formatMessage({id: errorMessage})}
          type="error"
          showIcon
        />
      )}
      {source && (
        <iframe className="scorm-player" title="SCORM_PLAYER" src={source}/>
      )}
    </Spinner>
  );
}

export default connect(mapStateToProps)(LearningActivity);
